export default {
  English: {
    signIn: ' Please sign the message to login to your account',
  },
  Spanish: {
    signIn: ' Por favor, firma el mensaje para iniciar tu sesión',
  },
};
